"use strict";
// https://github.com/Chia-Network/chia-blockchain/blob/b7e8e9c9a67fd696cfa2c16747d64dc0c3224611/chia/server/outbound_message.py#L10
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMsg = exports.Message = exports.Delivery = exports.NodeType = void 0;
const fields_1 = __importDefault(require("./fields"));
const serializer_1 = require("../serializer");
var NodeType;
(function (NodeType) {
    NodeType[NodeType["FULL_NODE"] = 1] = "FULL_NODE";
    NodeType[NodeType["HARVESTER"] = 2] = "HARVESTER";
    NodeType[NodeType["FARMER"] = 3] = "FARMER";
    NodeType[NodeType["TIMELORD"] = 4] = "TIMELORD";
    NodeType[NodeType["INTRODUCER"] = 5] = "INTRODUCER";
    NodeType[NodeType["WALLET"] = 6] = "WALLET";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
var Delivery;
(function (Delivery) {
    // A message is sent to the same peer that we received a message from
    Delivery[Delivery["RESPOND"] = 1] = "RESPOND";
    // A message is sent to all peers
    Delivery[Delivery["BROADCAST"] = 2] = "BROADCAST";
    // A message is sent to all peers except the one from which we received the API call
    Delivery[Delivery["BROADCAST_TO_OTHERS"] = 3] = "BROADCAST_TO_OTHERS";
    // A message is sent to a random peer
    Delivery[Delivery["RANDOM"] = 4] = "RANDOM";
    // Pseudo-message to close the current connection
    Delivery[Delivery["CLOSE"] = 5] = "CLOSE";
    // A message is sent to a speicific peer
    Delivery[Delivery["SPECIFIC"] = 6] = "SPECIFIC";
})(Delivery = exports.Delivery || (exports.Delivery = {}));
class Message {
}
__decorate([
    fields_1.default.Uint(8)
], Message.prototype, "type", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Uint(16))
], Message.prototype, "id", void 0);
__decorate([
    fields_1.default.Bytes()
], Message.prototype, "data", void 0);
exports.Message = Message;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function makeMsg(msgType, data) {
    const msg = new Message();
    msg.type = msgType;
    msg.id = null;
    msg.data = serializer_1.Serializer.serialize(data).toString("hex");
    return serializer_1.Serializer.serialize(msg);
}
exports.makeMsg = makeMsg;
//# sourceMappingURL=outbound_message.js.map